import React from "react";
import { useTranslation } from "react-i18next";
import Strip from "../Strip";
import IncomeTable from "../IncomeTable";
import AllContacts from "../AllContacts";

export default function Investment() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col">
      <div className="py-12 px-6 md:px-12">
        <Strip>{t("investment.title")}</Strip>
        <p className="text-xl mt-12">{t("investment.paragraph1")}</p>
        <p className="text-xl mt-4">{t("investment.paragraph2")}</p>
        <IncomeTable />
      </div>
      <AllContacts />
    </div>
  );
}
